import { connect } from 'react-redux';

import StatisticsTickDate from '@/components/StatisticsTickDate';
import { getTimeframe } from '@/features/anonymousPurchasesStatistics/selectors';
import { getScale } from '@/features/anonymousPurchasesStatisticsPage/selectors';

const mapStateToProps = (state, { itemId }) => ({
  date: getTimeframe(state, itemId),
  scale: getScale(state),
});

export default connect(mapStateToProps)(StatisticsTickDate);
